<template>
  <div v-if="getPerformanceData && getPerformanceData.cards" class="row">

    <div class="col-6 col-sm-3">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="flaticon-atm"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Total vendido
              </span>
              <h4 class="fw-black mb-8 lh-1">
                R$ {{ getPerformanceData.cards.amount_sold }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                Do primeiro ao último dia do mês
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-money"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Valor total atendimento
              </span>
              <h4 class="fw-black mb-8 lh-1">
                R$ {{ getPerformanceData.cards.total_value }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                Taxa de pagamento: <strong>R$ -{{ getPerformanceData.cards.tax }}</strong>
              </span>
              <span class="fw-medium text-dark-emphasis">
                Do primeiro ao último dia do mês
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="flaticon-check-mark-1"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Qtd. atendimentos
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getPerformanceData.cards.qtd_attendances }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="flaticon-users-group"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Qtd. clientes atendidos
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getPerformanceData.cards.number_of_customers_served }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "CardsFinancialManagement",
  data() {
    return {};
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      'getPerformanceData'
    ])
  },
});
</script>